import { useNavigate, useSearchParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, RotateCcw, ArrowLeft } from "lucide-react";

const REASONS = {
  cancelled: { title: "Payment cancelled", detail: "You cancelled the checkout. No charge was made." },
  failed:    { title: "Payment failed",    detail: "The transaction did not go through. No charge was made." },
  network:   { title: "Network error",     detail: "We lost connection to the payment provider. Please try again." },
  insufficient: { title: "Insufficient balance", detail: "Your wallet or card was declined for insufficient balance." },
};

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get("reason") || "cancelled";
  const feeId = params.get("fee_id");
  const info = REASONS[reason] || REASONS.cancelled;

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background p-6"
      data-testid="payment-cancel-page"
    >
      <Card className="max-w-md w-full p-8 border-border bg-white text-center">
        <XCircle className="w-12 h-12 mx-auto mb-4 text-destructive" />
        <div className="eyebrow text-muted-foreground">{reason.toUpperCase()}</div>
        <h1 className="font-display text-3xl font-bold mt-1" data-testid="payment-cancel-title">
          {info.title}
        </h1>
        <p className="text-muted-foreground text-sm mt-2" data-testid="payment-cancel-detail">
          {info.detail}
        </p>

        <div className="mt-6 flex flex-col gap-2">
          <Button
            className="w-full"
            onClick={() => navigate(feeId ? `/fees?retry=${feeId}` : "/fees")}
            data-testid="retry-payment"
          >
            <RotateCcw className="w-4 h-4 mr-2" /> Retry Payment
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => navigate("/dashboard")}
            data-testid="back-to-dashboard"
          >
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
